import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, normalizeStyle as _normalizeStyle, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "w-100" }

import { ref, getCurrentInstance, withDefaults, onMounted, watch } from 'vue';

	interface main {
		id ?: string | number,
		size ?: string,
		placeholder ?: string,
		ValueKey ?: string,
		LabelKey ?: string,
		width ?: string | number,
		disabled ?: boolean,
		IsAuto ?: boolean,
	}
export default /*#__PURE__*/_defineComponent({
  __name: 'CreatedUserSelect',
  props: {
    id: { default: "" },
    size: { default: "default" },
    placeholder: { default: "请选择创建人" },
    ValueKey: { default: "value" },
    LabelKey: { default: "label" },
    width: { default: "" },
    disabled: { type: Boolean, default: false },
    IsAuto: { type: Boolean, default: false }
  },
  emits: ["update:id", "change", "clear"],
  setup(__props: any, { emit: __emit }) {

	;

	const props = __props;

	const { proxy } = getCurrentInstance() as any;
	const emits = __emit;
	const UserId = ref<any>("");
	const OperatorList = ref<any>([]);
	const loading = ref(false);

	watch(() => props.id, (n : any) => {
		UserId.value = n;
	});

	onMounted(() => {
		UserId.value = props.id;
		if (props.IsAuto) {
			if (proxy.$store.state.IsRefreshOperatorList) {
				GetData();
			} else {
				if (proxy.$store.state.AdminUserList.length > 0) {
					OperatorList.value = proxy.$store.state.AdminUserList;
				} else {
					GetData();
				}
			}
		}
	});

	const WarehouseChange = (data : any) => {
		emits("update:id", data);
		emits("change", data);
	};
	const WarehouseClear = () => {
		emits("clear");
	};
	const SelectFocus = () => {
		if (proxy.$store.state.IsRefreshOperatorList) {
			GetData();
		} else {
			if (proxy.$store.state.AdminUserList.length > 0) {
				OperatorList.value = proxy.$store.state.AdminUserList;
			} else {
				GetData();
			}
		}
	};
	const GetData = () => {
		proxy.$api.tokenRequest({
			url: '/admin/admin',
			data: {
				nickname: "",
				phone: "",
				email: "",
				warehouse_id: "",
				auth_id: "",
				rfid: "",
				is_page: 0,
			},
			success: (res : any) => {
				OperatorList.value = res.data;
				proxy.$store.commit("GetAllList", {
					type: 30,
					data: res.data,
				});
			},
		});
	}

return (_ctx: any,_cache: any) => {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_select, {
      "remote-show-suffix": "",
      filterable: "",
      "reserve-keyword": "",
      clearable: "",
      style: _normalizeStyle({'width': `${_ctx.width}`}),
      disabled: _ctx.disabled,
      size: _ctx.size,
      modelValue: UserId.value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((UserId).value = $event)),
      loading: loading.value,
      remote: "",
      onFocus: SelectFocus,
      placeholder: _ctx.placeholder,
      onChange: WarehouseChange,
      onClear: WarehouseClear
    }, {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(OperatorList.value, (v) => {
          return (_openBlock(), _createBlock(_component_el_option, {
            key: v[_ctx.ValueKey],
            label: v[_ctx.LabelKey],
            value: v[_ctx.ValueKey]
          }, null, 8, ["label", "value"]))
        }), 128))
      ]),
      _: 1
    }, 8, ["style", "disabled", "size", "modelValue", "loading", "placeholder"])
  ]))
}
}

})